/*
 * This function stringifies and then parses a DOM.dataset object
 * note: we do this because Safari's implementation of Object.assign
 * cannot cope with DOMStringMap (the dataset).
 * note: Fixing this with Babel transform also isn't feasible: Babel polyfills
 * Object.assign, it doesn't replace it.*/

export function transformDataSet(dataset) {
    return JSON.parse(JSON.stringify(dataset));
}
